import { Fragment, useEffect } from "react";
import WebDesigner from "./WebDesigner";
import React from "react";
import { DefaultSiteData, PageData, SiteData } from "./Data/SiteData";
import { useDispatch, useSelector } from "react-redux";
import { GetSiteStyleAsync, getAllPagesContentless, GetBusinessLogo } from "./Utilities/PageDataHandler";
import { CreateBlankLayoutNode } from "./WBCanvas";
import 'vagaro-website-rendering/src/components/Styles/page.content.css'
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { GetLinearPageOptions } from "./Menus/PageSelectMenu";
import { useParams } from "react-router-dom";
import { LoginUserType, MobileCallbackTypes, ResponseCode, utils } from "utils/Utils";
import { useCookies } from "react-cookie";
import { CookieIds } from "./Menus/EditorSettings";

import { AttributeCollection } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import ValidateAllImages from "./ValidateAllImages";
import { GetBusinessDetails } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "components/Controls/VGPopUp";
import { AsyncAjaxPost } from "components/Common/AsyncAjaxService";
import { ActivateWB } from "components/Slice/Business";
import useSession from "components/Hook/useSession";
import Loader from "components/Common/Loader";
import SuccessPopup from "components/Migration/SwitchMysiteSuccess";
import { BlogBrowserWrapper } from "./Menus/BlogBrowser";




export default function WebDesignerManager() {


  enum SessionStatus {
    NotChecked,
    Valid,
    Invalid
  }

  const { StyleId, LayoutId } = useParams();
  const [loaded, setLoaded] = React.useState(false);
  const [sessionStatus, setSessionStatus] = React.useState(SessionStatus.NotChecked);
  const { IsNewCustomWebSite, AdminWhiteList, BusinessID, CountryID, UserID, ReactBusinessId, UserName, ReactUserID, CDNURL, UserType, BusinessName, AdminCDNURL, IsMultiLocation, MultiLocationBusinessList, IsViewAllowed, IsModifyAllowed, VagaroURL, BuildInDomain, CurrencySymbol, NewCustomizedWebsitePrice, Email, IsMutipleLocation, IsPromoCodeAddressBusiness, azContainer, azContainerURL, GroupMysite} = useSelector((state: any) => state.Business);


  const { access_token, generate_time } = useSelector((state: any) => state.Token);
  const [cookies] = useCookies();

  const CheckSession = async () => {

    return await useSession(dispatch, BusinessID, UserID, (data: any) => {


      if (data == true) {


        setSessionStatus(SessionStatus.Valid);

      }
      else {
        window.location.href = "https://www.vagaro.com/login";
        setSessionStatus(SessionStatus.Invalid);
      }
    });
  }



  /* compile the site data object */
  const siteData = DefaultSiteData;
  siteData.userContext.tokenExpiresAt = generate_time + 30 * 60000; //20 minutes reducing time as 40 was still expiring.
  siteData.userContext.businessId = BusinessID; //"Bo1ZyMjh1E13BbTWFirREG";//
  siteData.userContext.sitebid = BusinessID; //"Bo1ZyMjh1E13BbTWFirREG";//
  siteData.userContext.userId = ReactUserID;
  siteData.userContext.encUserId = UserID;
  siteData.userContext.styleId = StyleId;
  if (BuildInDomain && VagaroURL)
    siteData.vagaroURL = BuildInDomain + "/" + VagaroURL;
  siteData.userContext.layoutId = LayoutId;
  siteData.userContext.accessToken = access_token;
  siteData.userContext.userType = UserType;
  siteData.userContext.cdnURL = CDNURL;
  siteData.cdnUrl = CDNURL;
  siteData.isMultiLocation = IsMultiLocation && MultiLocationBusinessList && MultiLocationBusinessList.length > 0;
  siteData.AdminCDNURL = AdminCDNURL;
  siteData.isViewAllowed = IsViewAllowed;
  siteData.isModifyAllowed = IsModifyAllowed;
  if (MultiLocationBusinessList) {
    siteData.locations = MultiLocationBusinessList;
    siteData.userContext.MultilocationData = MultiLocationBusinessList;
  }
  siteData.userContext.countryCode = CountryID;
  siteData.userContext.userName = UserName;
  siteData.isMultipleLocation = IsMutipleLocation;
  siteData.isPromoCodeAddressBusiness = IsPromoCodeAddressBusiness; 
  siteData.azContainer = azContainer;
  siteData.azContainerURL = azContainerURL; 
  siteData.groupMysite = GroupMysite;





  /* Load editor settings from cookies */
  const simplyfyAdvancedSettings: any = cookies[CookieIds.simplifyAdvancedSettings];
  const showAddSectionButtons: any = cookies[CookieIds.showAddSectionButtons];
  const disableAnimations: any = cookies[CookieIds.disableAnimations];
  const autoSave: any = cookies[CookieIds.autoSave];
  const editorColorScheme: any = cookies[CookieIds.editorColorScheme];
  const autoCollapseExpandMenu: any = cookies[CookieIds.autoCollapseExpandMenu];
  const autoSaveFrequency: any = cookies[CookieIds.autoSaveFrequency];
  const optimization: any = cookies[CookieIds.optimization];

  if (simplyfyAdvancedSettings != undefined)
    siteData.editorSettings.advancedMenuIsModular = simplyfyAdvancedSettings == "true" ? true : false;

  if (showAddSectionButtons != undefined)
    siteData.editorSettings.showAddSectionButtons = showAddSectionButtons == "true" ? true : false;

  if (disableAnimations != undefined)
    siteData.editorSettings.disableAnimations = disableAnimations == "true" ? true : false;
  if (optimization != undefined) {
    siteData.editorSettings.opimizeRendering = optimization == "true" ? true : false;
    if (siteData.editorSettings.opimizeRendering == true) {
      (window as any).optimizevrendering = true;
    }
  }
  if (autoSave != undefined)
    siteData.editorSettings.autoSave = autoSave == "true" ? true : false;

  if (autoSaveFrequency != undefined) {
    const parse = parseInt(autoSaveFrequency);
    if (!isNaN(parse)) {
      siteData.editorSettings.autoSaveFrequency = parse;

    }
  }
  if (editorColorScheme != undefined) {
    let num = parseInt(editorColorScheme);
    if (!isNaN(num)) {
      siteData.editorSettings.editColorIndex = num;
    }
  }

  if (autoCollapseExpandMenu != undefined) {
    siteData.editorSettings.autoExpandCollapseRightMenu = autoCollapseExpandMenu == "true" ? true : false;
  }


  siteData.userContext.imageMapping = siteData.siteStyling.imageMapping;
  siteData.userContext.vgurl = siteData.vagaroURL??VagaroURL;


  const handleTouchMove = (e: TouchEvent) => {


    if (siteData.designer) {
      siteData.designer.handleTouchMove(e);
    }
  };
  const handleTouchStart = (e: TouchEvent) => {

    if (siteData.designer) {
      siteData.designer.handleTouchStart(e);
    }

  };
  const handleTouchEnd = (e: TouchEvent) => {

    if (siteData.designer) {
      siteData.designer.handleTouchUp(e);
    }
  };

  //HOIST touch events to the manager so that state changes don't interupt touch events in main designer

  useEffect(() => {
    CheckSession();
    //redirect to login if no valid business id is found.
    if (!siteData.userContext.businessId || siteData.userContext.businessId.length < 2) {

      window.location.href = "https://www.vagaro.com/login";
      return;
    }

    (window as any).isEditor = true;
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("touchstart", handleTouchStart, { passive: false });
    document.addEventListener("touchend", handleTouchEnd, { passive: false });

    return () => {
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleTouchEnd);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  siteData.userContext.isAdmin = (ReactBusinessId === 0 && UserType == LoginUserType.VagaroAdmin);



  let siteStyle = siteData.siteStyling;

  if (!siteStyle.colorPallet) {
    siteStyle.colorPallet = [];
  }

  while (siteStyle.colorPallet.length < 10) {
    siteStyle.colorPallet.push("#ffffff");
  }

  if (siteStyle.colorPallet.length > 10) {
    siteStyle.colorPallet = siteStyle.colorPallet.slice(0, 10);
  }

  if (!siteStyle.pageColor)
    siteStyle.pageColor = new AttributeCollection();


  if (siteData.userContext.isAdmin && AdminWhiteList && typeof AdminWhiteList == "string") {
    let list = AdminWhiteList.split(",");

    if (!list.includes(siteData.userContext.userId.toString()))
      siteData.isModifyAllowed = false;
  }



  async function Initialize() {
    const tryParseSiteData = (data: any) => {
      try {
        let parsed = JSON.parse(data.data.data.siteStyling);

        siteData.siteStyling = { ...DefaultSiteData.siteStyling, ...parsed.styling };

        siteData.imageUrls = parsed?.imageUrls ?? [];
        siteData.lastPublishDate = parsed.lastPublishDate ?? "";

        siteData.userContext.imageMapping = siteData.siteStyling.imageMapping;

        for (let i = 0; i < siteData.imageUrls.length; i++) {

          if (!siteData.imageUrls[i]) {

            siteData.imageUrls[i] = "not-found-" + i;
          }

        }

        if (!siteData.siteStyling.customFonts)
          siteData.siteStyling.customFonts = [];
        // siteData.homePageId = parsed.homePageId;

      } catch (e) {
        console.log("error parsing site settings", e);
      }
    }

    const getStyle = GetSiteStyleAsync(
      siteData.userContext,
      (data) => {
        if (data?.data?.data?.siteStyling) {
          tryParseSiteData(data);
        }




      },
      () => {



      }
    );


    const getPages = getAllPagesContentless(
      siteData.userContext,
      (data) => {


        siteData.pages = CreatePageDataFromAPI(data, siteData);



        let pageList = GetLinearPageOptions(siteData, false);

        let found = false;



        for (let i = 0; i < siteData.pages.length; i++) {

          const epage = siteData.pages[i];
          if (epage.isLandingPage) {
            siteData.homePageId = epage.pageId;

            found = true;

          }

          if (epage.isFolder && epage.children) {
            for (let ii = 0; ii < epage.children.length; ii++) {
              const eepage = epage.children[ii];
              if (eepage.isLandingPage) {
                found = true;

                siteData.homePageId = eepage.pageId;
                break;
              }
            }
          }

          if (found) {


            break;

          }

        }



        if (!found && pageList.length > 0) {

          siteData.homePageId = pageList[0].value;
        }

        siteData.userContext.pages = siteData.pages;

      },
      () => { }
    );

    const logoResult: any = {};
    const bDetailsResult = {
      result: null
    }
    const getLogo = GetBusinessLogo(siteData.userContext, (data) => { logoResult.data = data }, () => { });
    const getBusinessDetails = GetBusinessDetails(siteData.userContext, (data) => {
      bDetailsResult.result = data;
    }, () => { });

    await Promise.all([getStyle, getPages, getLogo, getBusinessDetails]).then((values) => {
      siteData.designer?.toggleLoading(false);
      setLoaded(true);


      let pageId = siteData.homePageId;

      if (window.location.search.includes("page=")) {

        let split = window.location.search.split("page=");
        if (split.length > 1) {
          let str = window.location.search.split("page=")[1];
          let id = str.split("&")[0];


          let options = GetLinearPageOptions(siteData, false);

          let get = options.find((e) => e.value == id);

          if (get)
            pageId = id;
        }


      }

      siteData.designer?.loadPageAsync(pageId);
      siteData.designer?.setState({ pageMenuLoadToggle: true });
      siteData.userContext.imageMapping = siteData.siteStyling.imageMapping;

      if (bDetailsResult.result) {
        const dResult: any = bDetailsResult.result;


        siteData.businessTabs.isPackageShow = dResult.isPackageShow;
        siteData.businessTabs.isShowBookNowTab = dResult.isShowBookNowTab;
        siteData.businessTabs.isShowClassTab = dResult.isShowClassTab;
        siteData.businessTabs.isShowServiceTab = dResult.isShowServiceTab;
        siteData.businessTabs.isShowProductTab = dResult.isShowProductTab;
        siteData.businessTabs.isShowGCTab = dResult.isShowGCTab;
        siteData.businessTabs.isShowMembership = dResult.isShowMembership;
        siteData.businessTabs.isShowDailyDeals = dResult.isShowDailyDeals;
      }

      const logoURL = logoResult.data?.data?.data?.imagePath ?? "";
      if (logoURL.length > 0) {

        siteData.logoUrl = logoURL;

        if (siteData.logoUrl && !siteData.imageUrls.includes(siteData.logoUrl)) {
          siteData.imageUrls.unshift(siteData.logoUrl);
        }
      }

      //@TODO REMOVE THIS LOGIC IN FUTURE RELEASE
      //HOT FIX TO UPDATE CDN URL ON OLDER IMAGES
      if (siteData.userContext.userType === LoginUserType.VagaroAdmin) {
        ValidateAllImages(siteData);
      }

      if (window.location.href.includes("?isProApp=true") && utils.IsFromProApp() == true) {
        publishpopupshow(siteData);
      }
      //END HOT FIX.

      if (window.location.href.includes("?isMigration=true")) {
        MigrationThankyouPopup();
      }

      if (window.location.href.includes("?IsBlog=true")) {
        OpenBlogPopup();
      }

    });

  }



  const MobileCallBack = () => {
    window.setMobileData = (res: any) => {
      let Response = JSON.parse(res);
      if (Response.callbackIndex) {
        if (Response.callbackIndex == 60) {
          if (Response.actionResponse.ReactReportIndex == 63 && Response.actionResponse.openWebControls == 25) {
            handlepopupClose();
            popupClose();
            ShowMenuPopup();
          }
        }
        if (Response.callbackIndex == 69) {
          if (Response.ReactReportIndex == 63) {
            window.location.href = "/";
          }
        }
      }
    }
  }

  const publishpopupshow = (siteData: any) => {
    utils.CallBackGivenToMobileApp(MobileCallbackTypes.DotWithBack, "Preview Mobile", 1, 63);
    return ReactDom.render(
      <VGPopUp
        id={"publishpopup"}
        onHide={handlepopupClose}
        show={true}
        isRemoveTabModalIndex={true}
        isShowFooter={true}
        dialogClassName="cancelauto-renew-alert app-alert-model publish-modal"
        body={<div> <ul className="publish-menu">
          <li ><div onClick={handlepopupClose}><span className="icon-box"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.25 0C15.8906 0 17.25 1.35938 17.25 3V21C17.25 22.6875 15.8906 24 14.25 24H3.75C2.0625 24 0.75 22.6875 0.75 21V3C0.75 1.35938 2.0625 0 3.75 0H14.25ZM15 21V3C15 2.625 14.625 2.25 14.25 2.25H3.75C3.32812 2.25 3 2.625 3 3V21C3 21.4219 3.32812 21.75 3.75 21.75H14.25C14.625 21.75 15 21.4219 15 21ZM9 18.375C9.60938 18.375 10.125 18.8906 10.125 19.5C10.125 20.1562 9.60938 20.625 9 20.625C8.34375 20.625 7.875 20.1562 7.875 19.5C7.875 18.8906 8.34375 18.375 9 18.375Z" fill="#333333" />
          </svg></span>
            Preview Mobile</div></li>
          <li ><div onClick={() => siteData?.designer?.tryPublishPage(false, true, () => { handlepopupClose(); PreviewDesktop(); })}> <span className="icon-box"><svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.5 0C26.1406 0 27.5 1.35938 27.5 3V16.5C27.5 18.1875 26.1406 19.5 24.5 19.5H17.5156L17.9844 21.75H20.375C20.9844 21.75 21.5 22.2656 21.5 22.875C21.5 23.5312 20.9844 24 20.375 24H7.625C6.96875 24 6.5 23.5312 6.5 22.875C6.5 22.2656 6.96875 21.75 7.625 21.75H9.96875L10.4375 19.5H3.5C1.8125 19.5 0.5 18.1875 0.5 16.5V3C0.5 1.35938 1.8125 0 3.5 0H24.5ZM15.6875 21.75L15.2188 19.5H12.7344L12.2656 21.75H15.6875ZM25.25 16.5V3C25.25 2.625 24.875 2.25 24.5 2.25H3.5C3.07812 2.25 2.75 2.625 2.75 3V16.5C2.75 16.9219 3.07812 17.25 3.5 17.25H24.5C24.875 17.25 25.25 16.9219 25.25 16.5Z" fill="#333333" />
          </svg></span> Preview Desktop</div></li>
        </ul>
        </div>}
        footer={<><button className="w-button w-button-primary" onClick={() => { IsNewCustomWebSite == false && ReactBusinessId > 0 ? ActivateWebsiteBuilderPopup() : siteData?.designer?.tryPublishPage(false); handlepopupClose() }}>Publish Website</button></>}
      />, document.getElementById("OpenDialog")
    )
  }

  const ShowMenuPopup = () => {
    utils.CallBackGivenToMobileApp(MobileCallbackTypes.DotWithBack, "Preview Mobile", 1, 63);
    return ReactDom.render(
      <VGPopUp
        id={"Showmenupopup"}
        onHide={handlepopupClose}
        show={true}
        isRemoveTabModalIndex={true}
        isShowFooter={true}
        dialogClassName="cancelauto-renew-alert app-alert-model publish-modal"
        body={<div> <ul className="publish-menu">
          <li ><div onClick={() => siteData?.designer?.tryPublishPage(false, true, () => { handlepopupClose(); PreviewDesktop(); })}> <span className="icon-box"><svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.5 0C26.1406 0 27.5 1.35938 27.5 3V16.5C27.5 18.1875 26.1406 19.5 24.5 19.5H17.5156L17.9844 21.75H20.375C20.9844 21.75 21.5 22.2656 21.5 22.875C21.5 23.5312 20.9844 24 20.375 24H7.625C6.96875 24 6.5 23.5312 6.5 22.875C6.5 22.2656 6.96875 21.75 7.625 21.75H9.96875L10.4375 19.5H3.5C1.8125 19.5 0.5 18.1875 0.5 16.5V3C0.5 1.35938 1.8125 0 3.5 0H24.5ZM15.6875 21.75L15.2188 19.5H12.7344L12.2656 21.75H15.6875ZM25.25 16.5V3C25.25 2.625 24.875 2.25 24.5 2.25H3.5C3.07812 2.25 2.75 2.625 2.75 3V16.5C2.75 16.9219 3.07812 17.25 3.5 17.25H24.5C24.875 17.25 25.25 16.9219 25.25 16.5Z" fill="#333333" />
          </svg></span> Preview Desktop</div></li>
          <li ><div onClick={() => { let siteURL = ("https://" + siteData.vagaroURL) ; utils.CallBackGivenToMobileApp(MobileCallbackTypes.MobileLink, siteURL); handlepopupClose(); }}><span className="icon-box"><svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5 11.3438V21.75C21.5 23.0156 20.4688 24 19.25 24H2.75C1.48438 24 0.5 23.0156 0.5 21.75V5.25C0.5 4.03125 1.48438 3 2.75 3H18.6406C19.1562 3 19.4375 3.60938 19.0625 3.98438L17.9375 5.10938C17.8438 5.20312 17.6562 5.25 17.5156 5.25H3.03125C2.84375 5.25 2.75 5.39062 2.75 5.53125V21.4688C2.75 21.6562 2.84375 21.75 3.03125 21.75H18.9688C19.1094 21.75 19.25 21.6562 19.25 21.4688V12.4688C19.25 12.3281 19.2969 12.1875 19.3906 12.0938L20.5156 10.9688C20.8906 10.5938 21.5 10.875 21.5 11.3438ZM26.9375 0C27.2188 0 27.5 0.28125 27.5 0.5625V6.9375C27.5 7.45312 26.8906 7.6875 26.5156 7.35938L24.2656 5.10938L11.5156 17.8594C11.2812 18.0938 10.9062 18.0938 10.7188 17.8594L9.64062 16.7812C9.40625 16.5938 9.40625 16.2188 9.64062 15.9844L22.3906 3.23438L20.1406 0.984375C19.7656 0.609375 20.0469 0 20.5625 0H26.9375Z" fill="#333333" />
          </svg></span>
            Launch Website</div></li>
          <li ><div onClick={() => { handlepopupClose(); WebVersion() }}> <span className="icon-box"><svg width="28" height="21" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.6875 17.9219C2.875 17.2656 3.25 16.6562 3.71875 16.1875L17.9688 1.9375C19.1406 0.765625 21.0625 0.765625 22.2344 1.9375L24.0625 3.76562C24.2031 3.90625 24.3438 4.09375 24.4375 4.23438C25.2344 5.40625 25.0938 7 24.0625 8.03125L9.8125 22.2812C9.76562 22.3281 9.67188 22.375 9.625 22.4688C9.15625 22.8438 8.64062 23.125 8.07812 23.3125L2.40625 24.9531C2.03125 25.0938 1.60938 25 1.32812 24.6719C1 24.3906 0.90625 23.9688 1 23.5938L2.6875 17.9219ZM3.76562 22.2344L7.42188 21.1562C7.51562 21.1094 7.65625 21.0625 7.75 21.0156L6.0625 20.6875C5.6875 20.5938 5.35938 20.3125 5.3125 19.9375L4.98438 18.25C4.9375 18.3438 4.89062 18.4844 4.84375 18.5781L3.76562 22.2344ZM9.4375 19.4688L18.9531 9.95312L16 7.04688L6.53125 16.5625L7 18.9531L9.4375 19.4688Z" fill="#333333" />
          </svg></span>Edit</div></li>
        </ul>
        </div>}
        footer={<><button className="w-button w-button-primary" onClick={() => { IsNewCustomWebSite == false && ReactBusinessId > 0 ? ActivateWebsiteBuilderPopup() : siteData?.designer?.tryPublishPage(false); handlepopupClose() }}>Publish Website</button></>}
      />, document.getElementById("OpenDialog")
    )
  }


  const PreviewDesktop = () => {
    utils.CallBackGivenToMobileApp(MobileCallbackTypes.DotWithBack, "Preview Mobile", 1, 63);
    return ReactDom.render(
      <VGPopUp
        id={"publishpopup"}
        show={true}
        isRemoveTabModalIndex={true}
        isShowFooter={true}
        dialogClassName="cancelauto-renew-alert app-alert-model"
        title={"Preview on Desktop"}
        body={<><div className="alertContent">An email with a preview link has been sent to {(Email == "" || Email == undefined || Email == null) ? "Business Owner" : Email}</div></>}
        footer={<><button onClick={popupClose} className="w-button w-button-primary" >OK</button></>}
      />, document.getElementById("OpenDialog1")
    )
  }

  const WebVersion = () => {
    utils.CallBackGivenToMobileApp(MobileCallbackTypes.DotWithBack, "Preview Mobile", 1, 63);
    return ReactDom.render(
      <VGPopUp
        id={"webversion"}
        show={true}
        isRemoveTabModalIndex={true}
        isShowFooter={true}
        dialogClassName="cancelauto-renew-alert app-alert-model"
        title={"Web Version Required"}
        body={<><div className="alertContent">To edit your website and access the website builder's full capabilities, go to Vagaro Web on a desktop browser.</div></>}
        footer={<><button onClick={popupClose} className="w-button w-button-primary" >OK</button></>}
      />, document.getElementById("OpenDialog1")
    )
  }

  const ActivateWebsiteBuilderPopup = async () => {
    utils.CallBackGivenToMobileApp(MobileCallbackTypes.DotWithBack, "Preview Mobile", 1, 63);
    return ReactDom.render(
      <VGPopUp
        id={"ActivateWebsiteBuilderPopup"}
        show={true}
        onHide={popupClose}
        title={"Upgrade Website Builder to Publish"}
        dialogClassName="cancelauto-renew-alert app-alert-model"
        body={
          <div className="alertContent">
            <p>
              Upgrade your website builder to {CurrencySymbol}{NewCustomizedWebsitePrice}/mo to get access to the builder's full functionality and publish your website live.
            </p>
          </div>
        }
        footer={
          <Fragment>

            <button className="w-button w-button-primary" onClick={() => { ActivateDeactiveWebsiteBuilder(); }}>Upgrade {CurrencySymbol}{NewCustomizedWebsitePrice}/mo</button>
          </Fragment >
        }
        isRemoveTabModalIndex={false}
        isShowFooter={true}
        size={"md"}
        backdrop={true}
      />,
      document.getElementById("OpenDialog1")
    );
  }

  const MigrationThankyouPopup = () => {
    return ReactDom.render(
      <SuccessPopup VagaroURL={VagaroURL} BuildInDomain={BuildInDomain} />,
      document.getElementById("component-context-migration")
    );
  }

  const OpenBlogPopup = () => {
    const urlWithoutQuery = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, urlWithoutQuery);
    let des = (window as any).webDesigner as WebDesigner;
    des.openToBlogSettings();
  }

  const dispatch = useDispatch();

  const ActivateDeactiveWebsiteBuilder = async () => {
    utils.CallBackGivenToMobileApp(MobileCallbackTypes.DotWithBack, "Preview Mobile", 1, 63);
    let data;
    data = {
      isnewcustomwebsite: true,
      userId: siteData.userContext.userId,
    };
    await AsyncAjaxPost(
      siteData.userContext.businessId + "/domainprocess/activatedeactivewebsitebuilder",
      data,
      siteData.userContext.accessToken,
      function onSuccess(data: any) {
        try {
          if (
            data != null &&
            data.data != null &&
            data.data.responseCode == ResponseCode.Success
          ) {
            if (data != null && data.data != null && data.data.data != null && data.data.data.status) {
              dispatch(ActivateWB({ type: "activate" }));

              siteData?.designer?.tryPublishPage(false);
              popupClose();
            }
            else {

            }
          }
        }
        catch (error) {

        }
      },
      function OnError() {

      }
    )
  }


  const handlepopupClose = () => {
    unmountComponentAtNode(document.getElementById("OpenDialog") as any);
  }
  const popupClose = () => {
    unmountComponentAtNode(document.getElementById("OpenDialog1") as any);
  }

  useEffect(() => {
    if (sessionStatus === SessionStatus.Valid)
      Initialize();
    if (utils.IsFromProApp()) {
      MobileCallBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionStatus]);


  if (sessionStatus === SessionStatus.NotChecked) {
    return <Loader />
  }



  if (!siteData.userContext.businessId || siteData.userContext.businessId.length < 2)
    return <></>


  return (
    <>
      {/* <FontLinks /> */}
      <div id="version-history-popup"></div>
      <div id="component-context-menu"></div>
      <div id="component-context-migration"></div>
      <WebDesigner
        isPromoBusiness = {IsPromoCodeAddressBusiness}
        layout={CreateBlankLayoutNode(wBComponentTypeNames.pageRoot)}
        siteData={siteData}
        startLoading={!loaded}
        styleId={StyleId}
        layoutId={LayoutId}
        reactBusinessId={ReactBusinessId}
        businessName={BusinessName}
        dispatch={dispatch}
      />


      {!siteData.userContext.isAdmin && window.location.href.includes("/admin/") && siteData.isModifyAllowed && siteData.pages.length > 0 &&
        <>

          <div className="block-edit center-all font-bold font-large" style={{ position: "fixed", left: "0", top: "0", color: "#333", background: "#fff", width: "100%", height: "100%", zIndex: "1010000" }}><div style={{ paddingBottom: "150px" }}>Getting your site ready...</div><div className="loader-imgNew"></div></div>

        </>
      }
      {/* {!isProApp&&
        <div className="width-not-supported gap-med">
       <svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 640 640" fill="white"><path d="M0 128c0-9.7 2.2-19 6.1-27.2c14 11 28 22 41.9 33c0 83.4 0 166.8 0 250.2c0 8.8 7.2 16 16 16c107.3 0 214.6 0 321.8 0c20.3 16 40.6 32 60.9 48c-127.6 0-255.2 0-382.8 0c-35.3 0-64-28.7-64-64c0-85.3 0-170.6 0-256zM5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1C63.9 24.7 88.9 44.4 113.9 64c154 0 308 0 462.1 0c35.3 0 64 28.7 64 64c0 85.3 0 170.6 0 256c0 27.3-17.2 50.7-41.4 59.9c10.7 8.4 21.5 16.8 32.2 25.2c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1C403.8 352.2 206.5 197.6 9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM175.2 112c122.5 96 245 192 367.4 288c11.1 0 22.2 0 33.4 0c8.8 0 16-7.2 16-16c0-85.3 0-170.6 0-256c0-8.8-7.2-16-16-16l-400.8 0z"></path></svg>

           <div style={{maxWidth:"240px"}}> Please try rotating to landscape mode or using a different device.</div>
         <div className="font-small">Minimum width required for editor: 700 pixels</div>
       </div>
  } */}


    </>
  );
}


// function FontLinks() {

//   return <>
//     {googleFonts.map((font, index) => {



//       return <link
//         rel="stylesheet"
//         key={index}
//         href={"https://fonts.googleapis.com/css2?family=" + font.replaceAll(" ", "+")}
//       />
//     })}
//   </>

// }
declare global {
  interface Window { setMobileData: any; }
}

export function CreatePageDataFromAPI(data: any, siteData: SiteData) {


  if (!data?.data?.data) {
    console.warn("Missing page data");
    return [];
  }



  const allPages: PageData[] = [];
  const pages = data.data.data;


  for (let i = 0; i < pages.length; i++) {
    let rawPage = pages[i];


    // if(rawPage.urlSlug == "/"+ProductDetailsSlug){ // store product page seperately from other pages so user can not access or edit it
    //   siteData.productPageId  = rawPage.pageId;
    //   continue;

    // }
    let url = rawPage.isExternalLink? (rawPage.externalLinkURL??""):( rawPage.urlSlug ?? "").replace("/", "");



    let pageData: PageData = {
      name: rawPage.pageName ?? "",
      url: (url ?? ""), //remove forward slash in working page Data
      isExternalLink: rawPage.isExternalLink,
      isExternalLinkNewTab: rawPage.isExternalLinkNewTab,
      pageId: rawPage.pageId ?? "",
      titleTag: rawPage.titleTag ?? "",
      isDisabled: rawPage.isDisable ?? false,
      content: rawPage.content ?? "",
      metaDescription: rawPage.description ?? "",
      order: rawPage.pageOrder ?? 0,
      folderId: rawPage.folderId ?? "",
      isFolder: rawPage.isFolder ?? "",
      openGraphImageUrl:(rawPage.isExternalLink)?"": rawPage.openGraphURL ?? "",
      children: [],
      isLandingPage:(rawPage.isExternalLink)?false: rawPage.isHomePage ?? false,
      isHidePage: (rawPage.isExternalLink)?false:rawPage.isHidePage ?? false,
      isDuplicateAllLocationPage:(rawPage.isExternalLink)?false: rawPage.isDuplicateAllLocationPage ?? false,
    };

    //avoid duplicates
    let found = false;
    for (let i = 0; i < allPages.length; i++) {
      if (allPages[i].pageId == pageData.pageId) {
        console.warn("avoiding duplicate page");
        found = true;
        break;
      }
    }

    if (!found)
      allPages.push(pageData);

  }


  allPages.sort((a, b) => {
    let ao = a.order ?? 0;
    let bo = b.order ?? 0;
    return ao - bo;
  });


  //create folder structure
  for (let i = 0; i < allPages.length; i++) {
    let evalPage = allPages[i];
    if (evalPage.url && evalPage.url.includes("/")&&!evalPage.isExternalLink) {
      evalPage.url = evalPage.url.replace("/", "");
    }
    if (evalPage.folderId != null && evalPage.folderId.length > 0) {

      for (let e = 0; e < allPages.length; e++) {
        let compare = allPages[e];

        if (compare.isFolder && evalPage.folderId == compare.pageId) {
          if (compare.children)
            // should always be defined as we set this to [] in inital creation
            compare.children.push(evalPage);

          allPages.splice(i, 1);
          i--;
          break;
        }
      }
    }
  }


  return allPages;



}
